import { toQueryParams } from '@/helpers/ApiHelper'
import type { IRestrictorMas } from '@/models/IRestrictorMas'
import type { IFirmwareForModel } from '@/models/Manufacturer/IFirmwareForModel'
import type { IManufacturer } from '@/models/Manufacturer/IManufacturer'
import type { IModel } from '@/models/Manufacturer/IModel'
import { inject, injectable } from 'inversify'
import type IApiClient from '../IApiClient'
import { SERVICES_TYPES } from '../ServicesTypes'
import type { IManufacturerService } from './IManufacturerService'

@injectable()
export class ManufacturerService implements IManufacturerService {
  private readonly apiClient: IApiClient
  private readonly manufacturerUri: string = 'manufacturers'

  constructor(@inject(SERVICES_TYPES.ApiClient) apiClient: IApiClient) {
    this.apiClient = apiClient
  }

  public getManufacturers(restrictor?: IRestrictorMas): Promise<IManufacturer[]> {
    let uri = this.manufacturerUri
    const restrictions = restrictor ? toQueryParams<IRestrictorMas>(restrictor) : undefined
    uri += restrictions ? `?${restrictions}` : ''
    return this.apiClient.get<IManufacturer[]>(uri)
  }

  public getModelsForManufacturer(manufacturerCode: string, restrictor?: IRestrictorMas): Promise<IModel[]> {
    let uri = `${this.manufacturerUri}/${manufacturerCode}/models`
    const restrictions = restrictor ? toQueryParams<IRestrictorMas>(restrictor) : undefined
    uri += restrictions ? `?${restrictions}` : ''
    return this.apiClient.get<IModel[]>(uri)
  }

  public getFirmwaresForModel(manufacturerCode: string, modelCode: string, restrictor?: IRestrictorMas): Promise<IFirmwareForModel[]> {
    let uri = `${this.manufacturerUri}/${manufacturerCode}/models/${modelCode}/firmware`
    const restrictions = restrictor ? toQueryParams<IRestrictorMas>(restrictor) : undefined
    uri += restrictions ? `?${restrictions}` : ''
    return this.apiClient.get<IFirmwareForModel[]>(uri)
  }
}
